import { OrganisationPageRouteBuilder } from "@org-common/lib/route/organisation-page-route-builder";
import { CommonFontsAndColorsPageComponent } from "./common-fonts-and-colors-page.component";

export const commonFontsAndColorsPageRoute = new OrganisationPageRouteBuilder()
    .usingNgComponent("adapt-common-fonts-and-colors-page", CommonFontsAndColorsPageComponent)
    .atUrl("/about/theme-test/common-fonts-and-colors")
    .requiresLogin(false)
    .build();
